<mat-card class="my-card">
    <form [formGroup]="resetPasswordForm" class="my-form" (submit)="resetPassword()">
        <mat-card-content>
            <mat-form-field appearance="outline" class="full-width">
                <mat-label>Enter your registered email ID</mat-label>
                <input matInput type="email" placeholder="Email" id="userEmail" formControlName="userEmail"
                    class="form-control" required>
                <mat-error *ngIf="userEmail.invalid && (userEmail.dirty || userEmail.touched)">
                    {{getEmailErrorMessage()}}
                </mat-error>
            </mat-form-field>

            <mat-form-field appearance="outline" class="full-width">
                <mat-label> Reset Password </mat-label>
                <input matInput type="password" placeholder="Password" id="userPassword" formControlName="userPassword"
                    class="form-control" required>
                <mat-error *ngIf="userPassword.invalid && (userPassword.dirty || userPassword.touched)">
                    {{getPasswordErrorMessage()}}
                </mat-error>
            </mat-form-field>

            <mat-form-field appearance="outline" class="full-width">
                <mat-label> Confirm Password </mat-label>
                <input matInput type="password" placeholder="Password" id="confirmPassword" formControlName="confirmPassword"
                    class="form-control" required>
                <mat-error *ngIf="confirmPassword.invalid && (confirmPassword.dirty || confirmPassword.touched)">
                    {{passwordMatch()}} {{getPasswordErrorMessage()}}
                </mat-error>
            </mat-form-field>

        </mat-card-content>
        <mat-card-actions>
            <button style ="margin-left:1%" mat-raised-button (click)="resetPassword()" color="accent">Reset Password</button>
        </mat-card-actions>
    </form>
</mat-card>